import { ServiceCategory } from '@prisma/client';
import qs from 'qs';
import API_URL from '../apiconfig';
import { AvailableTimes, UnavailableTimes } from '../interfaces';
import axios from './api';
import { TakenSessionSlot } from '../types/appointments';
import { MAX_APPOINTMENT_LENGTH_IN_MINUTES } from '../constants/appointments';

export async function getAvailableDays({
  startDate,
  endDate,
  duration,
  employeeId,
  timezone,
  isConsultation,
  businessId,
  rescheduleAppointmentId,
  serviceCategory,
  takenSlots,
  customerView,
}: {
  startDate: string;
  endDate: string;
  duration: number;
  employeeId: string;
  timezone: string;
  isConsultation?: boolean;
  serviceCategory?: ServiceCategory;
  businessId?: string;
  rescheduleAppointmentId?: string;
  takenSlots?: TakenSessionSlot[];
  customerView?: boolean;
}) {
  try {
    const response = await axios.get(`${API_URL}/v1/availability`, {
      params: {
        by: 'time',
        startDate,
        endDate,
        duration: Math.min(duration, MAX_APPOINTMENT_LENGTH_IN_MINUTES),
        employeeId,
        timezone,
        businessId,
        rescheduleAppointmentId,
        serviceCategory,
        takenSlots: takenSlots?.length ? JSON.stringify(takenSlots) : undefined,
        isConsultation,
        customerView,
      },
    });

    return response.data.result as {
      availableTimes: AvailableTimes[];
    };
  } catch (error) {
    throw new Error('Cannot get available days', { cause: error });
  }
}

export async function getAvailableTimes({
  startDate,
  endDate,
  duration,
  employeeId,
  timezone,
  isConsultation,
  businessId,
  rescheduleAppointmentId,
  serviceCategory,
  takenSlots,
  customerView,
}: {
  startDate: string;
  endDate: string;
  duration: number;
  employeeId: string;
  timezone: string;
  isConsultation?: boolean;
  serviceCategory?: ServiceCategory;
  businessId?: string;
  rescheduleAppointmentId?: string;
  takenSlots?: TakenSessionSlot[];
  customerView?: boolean;
}) {
  try {
    const response = await axios.get(`${API_URL}/v1/availability`, {
      params: {
        by: 'time',
        startDate,
        endDate,
        duration: Math.min(duration, MAX_APPOINTMENT_LENGTH_IN_MINUTES),
        employeeId,
        timezone,
        businessId,
        rescheduleAppointmentId,
        serviceCategory,
        takenSlots: takenSlots?.length ? JSON.stringify(takenSlots) : undefined,
        isConsultation,
        customerView,
      },
    });

    return response.data.result as { availableTimes: AvailableTimes[] };
  } catch (error) {
    throw new Error('Cannot get available times', { cause: error });
  }
}

export async function getUnavailability({
  startDate,
  endDate,
  employeeId,
}: {
  startDate: string;
  endDate: string;
  employeeId: string;
}) {
  try {
    const response = await axios.get(
      `${API_URL}/v1/availability/unavailability`,
      {
        params: {
          startDate,
          endDate,
          employeeId,
        },
      },
    );

    return response.data.result as UnavailableTimes[];
  } catch (error) {
    throw new Error('Cannot get unavailability', { cause: error });
  }
}

export async function getUnavailabilityBatch({
  employeeIds,
  startDate,
  endDate,
  signal,
}: {
  employeeIds: string[];
  startDate: string;
  endDate: string;
  signal?: AbortSignal;
}) {
  const response = await axios.get(
    `${API_URL}/v1/availability/unavailability/batch`,
    {
      params: {
        employeeIds,
        startDate,
        endDate,
      },
      paramsSerializer: params =>
        qs.stringify(params, {
          arrayFormat: 'repeat',
        }),
      signal,
    },
  );

  return response.data.result as Record<string, UnavailableTimes[]>;
}
